export class AllergyDataModel {
    SLNO: string;
    AlertCode: string;
    AlertName: string;
    Remarks: string;
    Severity: string;
    Reaction: string;
    Inactive: string;
    Active: string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/allergy/allergydatamodel.ts